module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_8011.b8677924.png";